/* eslint-disable import/no-cycle */
import {observer} from 'mobx-react-lite';
import {useMount} from '../../../hooks/useMount';
import Form from '../form/Form';
import WidgetSettingFormField from './WidgetSettingFormField';
import Tabs from '../tabs/Tabs';

const {TabPane} = Tabs;

const WidgetSettingsForm = ({widgetConfig = {}, form}) => {
  useMount(() => {
    form.setFieldsValue(widgetConfig.getValues());
  });

  return (
    <Tabs>
      {widgetConfig.tabs.map((tab) => (
        widgetConfig[tab.key]?.length
          ? (
            <TabPane
              tab={(
                <span>
                  {tab.label}
                </span>
              )}
              key={tab.key}
              forceRender
            >
              <Form
                form={form}
              >
                {
                  widgetConfig[tab.key].map((field) => (
                    <div key={field.id}>
                      <WidgetSettingFormField field={field} form={form}/>
                    </div>
                  ))
                }
              </Form>
            </TabPane>
          )
          : null
      ))}
    </Tabs>
  );
};

export default observer(WidgetSettingsForm);
